import { baseApi } from "./api";
import { IProfile } from "../interfaces/Iprofile";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

const PROFILE_ROUTES = {
  GET_PROFILE: "/auth/profile",
  UPDATE_PROFILE: "/auth/profile",
};

const profileApi = {
  getProfile: async () => {
    const response = await baseApi.get(PROFILE_ROUTES.GET_PROFILE);
    return response;
  },
  updateProfile: async (data: IProfile) => {
    console.log("profileApi.updateProfile - sending data:", data);
    console.log("profileApi.updateProfile - timezone:", data.timezone);
    const response = await baseApi.put(PROFILE_ROUTES.UPDATE_PROFILE, data);
    return response;
  },
};

// React Query hooks
export function useProfile() {
  return useQuery({ queryKey: ["profile"], queryFn: profileApi.getProfile });
}

export function useUpdateProfile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: profileApi.updateProfile,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["profile"] });
    },
  });
}

export { profileApi };
